module.exports = __webpack_public_path__ + "media/belts_levels_selection.669850c3.wav";